module.exports = __webpack_public_path__ + "assets/images/logo.c59cb9d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 169
// module chunks = 1